import { render, staticRenderFns } from "./Identification.vue?vue&type=template&id=da708a0c"
import script from "./Identification.vue?vue&type=script&lang=ts"
export * from "./Identification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports